import type { FindAJobDropdownData } from '#/components/FindAJobDropdown/types/FindAJobDropdownData';
import type { I18nLocale } from '#/i18n/types/I18nLocale';

import { findAJobDropdownDataEn } from './findAJobDropdownData.en';
import { findAJobDropdownDataEs } from './findAJobDropdownData.es';
import { findAJobDropdownDataPt } from './findAJobDropdownData.pt';

export const findAJobDropdownDataByLocale: Record<
  I18nLocale,
  FindAJobDropdownData
> = {
  en: findAJobDropdownDataEn,
  es: findAJobDropdownDataEs,
  pt: findAJobDropdownDataPt,
};
